import { useCallback, memo, useRef } from "react";
import { MentionModel } from "../communication";
import { crossSVG } from "../constants";

interface SearchBarProps {
	searchText: string;
	mentionModel: MentionModel;
	setSearchText: (text: string) => void;
	setOpen: (open: boolean) => void;
	deactivateStrutureIds: () => void;
}

const charSetArray = [
	".",
	"+",
	"*",
	"?",
	"^",
	"$",
	"(",
	")",
	"[",
	"]",
	"{",
	"}",
	"|",
	"\\",
];
const specialCharSet = new Set<String>(charSetArray);

function SearchBar(props: SearchBarProps) {
	const inputRef = useRef<HTMLInputElement>(null);
	const inputChangeHandler = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			e.stopPropagation();
			props.setSearchText(e.target.value);
			if (e.target.value.length === 0) {
				props.setOpen(false);
				props.deactivateStrutureIds();
			}
		},
		[props.setSearchText]
	);

	const keydownHandler = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>) => {
			e.stopPropagation();
			if (e.key === "Escape") {
				props.setOpen(false);
			} else if(e.key === "Enter") {
				e.preventDefault();
				inputRef.current?.blur();
			}else if (specialCharSet.has(e.key)) {
				e.preventDefault();
			}
		},
		[]
	);

	return (
		<div className={"search-bar " + props.mentionModel}>
			<input
				type="text"
				className="search"
				placeholder={"Search " + props.mentionModel}
				value={props.searchText}
				onChange={inputChangeHandler}
				onKeyDown={keydownHandler}
				autoFocus
				ref={inputRef}
			/>
			<div
				onClick={(e: React.MouseEvent) => {
					props.setSearchText("");
					props.setOpen(false);
				}}
				className="search-close-button"
			>
				{crossSVG}
			</div>
		</div>
	);
}

export default memo(SearchBar);
